import { render, staticRenderFns } from "./ProductsSortCategory.vue?vue&type=template&id=61b7377e&scoped=true"
import script from "./ProductsSortCategory.vue?vue&type=script&lang=js"
export * from "./ProductsSortCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductsSortCategory.vue?vue&type=style&index=0&id=61b7377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7377e",
  null
  
)

export default component.exports